"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_2 = require("@nextui-org/react");
var main_1 = require("../../../../../reducers/slices/main");
var add_driver_1 = __importDefault(require("../components/add_driver"));
var pair_driver_1 = __importDefault(require("../components/pair_driver"));
var permissions_1 = __importDefault(require("../../../../../hooks/permissions"));
var IUser_1 = require("../../../../../interfaces/IUser");
var delete_driver_thunk_1 = require("../../../../../reducers/slices/driver/thunks/delete_driver_thunk");
var useRowActions = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var permissions = (0, permissions_1.default)(IUser_1.IPermissions.DRIVERS);
    var rowActions = function (cellValue) { return [
        {
            key: "edit",
            onClick: function () {
                dispatch((0, main_1.setContentModal)({
                    title: "Edit Driver",
                    content: (0, jsx_runtime_1.jsx)(add_driver_1.default, { driver: cellValue }),
                }));
            },
        },
        {
            key: "pair/unpair",
            onClick: function () {
                dispatch((0, main_1.setContentModal)({
                    title: "Pair Driver",
                    content: (0, jsx_runtime_1.jsx)(pair_driver_1.default, { driver: cellValue }),
                }));
            },
        },
        (permissions === null || permissions === void 0 ? void 0 : permissions.canDelete) && {
            key: "delete",
            onClick: function () {
                return dispatch((0, main_1.setContentModal)({
                    title: "Delete Driver?",
                    content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col justify-start pt-4" }, { children: [(0, jsx_runtime_1.jsxs)("h3", __assign({ className: "text-lg font-normal mb-4" }, { children: ["Are you sure you want to delete ", cellValue.name, " ", cellValue.surname, "?"] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4 pt-4 justify-start" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "danger", variant: "light", onPress: function () { return dispatch((0, main_1.setContentModal)(null)); } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "primary", onPress: function () { return dispatch((0, delete_driver_thunk_1.delete_driver_thunk)({ _id: cellValue._id })); } }, { children: "Continue" }))] }))] }))),
                }));
            },
        },
    ]; };
    return (0, react_1.useMemo)(function () { return ({
        rowActions: rowActions,
    }); }, [rowActions]);
};
exports.useRowActions = useRowActions;
